import type {SkipToken} from '@reduxjs/toolkit/query'
import {skipToken} from '@reduxjs/toolkit/query'
import {useMemo} from 'react'

import type {Build} from '../../../../../services/rest'
import {restApi} from '../../../../../services/rest'
import type {BuildId} from '../../../../../types'

export const downloadedArtifactsFields =
  'downloadedArtifacts(downloadInfo(build(id),artifactInfo(path)))'

export const getDownloadedArtifactsArg = (buildId: BuildId) => ({
  buildLocator: `id:${buildId}`,
  fields: downloadedArtifactsFields,
})

export const getArtifactInfo = (data: Build | undefined, from: BuildId) =>
  data?.downloadedArtifacts?.downloadInfo?.find(({build}) => build?.id === from)?.artifactInfo

export const useDownloadedArtifacts = (from: BuildId, to: BuildId | SkipToken) => {
  const {artifactInfo} = restApi.endpoints.getBuild.useQuery(
    to !== skipToken ? getDownloadedArtifactsArg(to) : skipToken,
    {
      selectFromResult: ({data}) => ({
        artifactInfo: getArtifactInfo(data, from),
      }),
    },
  )
  return useMemo(() => artifactInfo?.map(({path = ''}) => path), [artifactInfo])
}
